import {
  EventNotificationFrequencyRealTime,
  EventNotificationFrequencyWeekly,
  Waterbody,
  WaterbodyEventNotifications,
} from '@omniafishing/core';
import { Checkbox, Form, Input, Radio } from 'antd';
import { FormInstance } from 'antd/lib/form';
import React from 'react';
import { useUser } from '../../hooks/use_user';
import cssStyles from './waterbody_notifications_form.less';

export interface WaterbodyNotificationsFormProps {
  waterbody: Waterbody;
  event_notifications: WaterbodyEventNotifications;
  favorite: boolean;
  formRef: React.RefObject<FormInstance>;
}

export const WaterbodyNotificationsForm: React.FC<WaterbodyNotificationsFormProps> = (props) => {
  const { formRef, waterbody, favorite, event_notifications } = props;

  const { user } = useUser();
  const isFavorite = favorite;

  const formFields = {
    new_fishing_report: 'new_fishing_report',
    new_article: 'new_article',
    email: 'email',
    frequency: 'frequency',
  };

  return (
    <Form
      ref={formRef}
      initialValues={{
        [formFields.new_fishing_report]: isFavorite ? event_notifications.new_fishing_report : true,
        [formFields.new_article]: isFavorite ? event_notifications.new_article : true,
        [formFields.frequency]: isFavorite
          ? event_notifications.frequency
          : EventNotificationFrequencyWeekly,
      }}
      layout="vertical"
    >
      <p>Get Updates on {waterbody.primary_name}</p>

      {user == null && (
        <Form.Item
          name={formFields.email}
          className={cssStyles.item}
          label="Email"
          rules={[{ required: true, message: 'Please input your email' }]}
        >
          <Input type="email" />
        </Form.Item>
      )}

      <Form.Item
        name={formFields.new_fishing_report}
        className={cssStyles.item}
        valuePropName="checked"
      >
        <Checkbox>Fishing Reports</Checkbox>
      </Form.Item>

      <Form.Item name={formFields.new_article} className={cssStyles.item} valuePropName="checked">
        <Checkbox>New Videos &amp; Articles</Checkbox>
      </Form.Item>

      <Form.Item name={formFields.frequency} label="How often do you want updates?">
        <Radio.Group
          options={[
            { label: 'Realtime', value: EventNotificationFrequencyRealTime },
            { label: 'Weekly', value: EventNotificationFrequencyWeekly },
          ]}
          optionType="button"
        />
      </Form.Item>
    </Form>
  );
};
